import '@resources/fontes/fontes.css'
import '@resources/css/report.css'
import Header from '@components/Header/Header'
import Sidebar from '@components/Sidebar/Sidebar'
import { Link } from 'react-router-dom'
import React from 'react'
import { BsChevronRight } from 'react-icons/bs'
import HeroBanner from './Report/components/HeroBanner'
import PregnancyReportForm from './Report/components/PregnancyReportForm'

const Report: React.FC<any> = () => {
  return (
    <div className="client-report-page d-lg-flex justify-content-lg-center">
      <Sidebar />
      <main className="with-fixed-nav">
        <Header showSidebarOpenButton />
        <div className="row mt-4">
          <div className="col-auto pr-0">
            <Link to="/" className="text-body d-flex align-items-center">Catálogo</Link>
          </div>
          <div className="col-auto pl-1 pr-1">
            <BsChevronRight size={10} />
          </div>
          <div className="col-auto p-0">
            <a href="#" className="id d-flex align-items-center font-weight-bold">
              Reporte sua gestação
            </a>
          </div>
        </div>
        <section className="mt-5">
          <p className="mb-4 lead text-justify" style={{ fontWeight: 500 }}>
            Torcemos muito pelo seu positivo, e queremos saber como está o
            andamento da sua gravidez ou o nascimento do(s) seu(s) bebê(s).
          </p>
          <div className="d-flex flex-column" style={{ gap: '1.5rem' }}>
            <HeroBanner />
            <PregnancyReportForm />
          </div>
        </section>
      </main>
    </div>
  )
}

export default Report
